(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Lovelle-Announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lovelle-announcement')) {
    class LovelleAnnouncement extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.messages = [...this.querySelectorAll('[data-message]')];
        this.index = 0;
        this.paused = false;
        this.hovered = false;
        this.focused = false;
        this.editorSelected = false;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.live = this.querySelector('[aria-live]');
        this.pauseButton = this.querySelector('[data-pause]');
        if (this.messages.length < 2) return;
        this.querySelectorAll('[data-prev], [data-next]').forEach(button => {
          button.hidden = false;
          button.addEventListener('click', () => {
            this.show(this.index + (button.hasAttribute('data-next') ? 1 : -1), true);
            this.schedule();
          }, options);
        });
        if (this.pauseButton) {
          this.pauseButton.hidden = false;
          this.pauseButton.addEventListener('click', () => {
            this.paused = !this.paused;
            this.updatePause();
            this.schedule();
          }, options);
        }
        this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
        this.addEventListener('focusout', () => {
          queueMicrotask(() => {
            if (!this.isConnected) return;
            this.focused = this.contains(document.activeElement);
            this.schedule();
          });
        }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => this.schedule(), options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.messages.findIndex(message => message.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          this.editorSelected = true;
          this.show(index, true);
          this.schedule();
        }, options);
        document.addEventListener('shopify:block:deselect', event => {
          if (!this.messages.some(message => message.dataset.blockId === event.detail.blockId)) return;
          this.editorSelected = false;
          this.schedule();
        }, options);
        this.schedule();
      }
      show(index, announce = false) {
        this.index = (index + this.messages.length) % this.messages.length;
        this.live.setAttribute('aria-live', announce ? 'polite' : 'off');
        this.messages.forEach((message, position) => { message.hidden = position !== this.index; });
      }
      updatePause() {
        this.pauseButton.setAttribute('aria-label', this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel);
        this.pauseButton.querySelector('span').textContent = this.paused ? '▶' : 'Ⅱ';
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.isConnected || this.messages.length < 2 || this.dataset.rotate !== 'true' || this.paused || this.hovered || this.focused || this.editorSelected || this.motion.matches || document.hidden) return;
        this.timer = setTimeout(() => {
          this.show(this.index + 1);
          this.schedule();
        }, Number(this.dataset.delay) || 5000);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
      }
    }
    customElements.define('lovelle-announcement', LovelleAnnouncement);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lovelle-categories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lovelle-category-list')) {
    class LovelleCategoryList extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('.lovelle-categories__track');
        this.controls = this.querySelector('.lovelle-categories__controls');
        this.media = matchMedia('(max-width: 749px)');
        if (!this.track) return;
        this.querySelectorAll('[data-direction]').forEach(button => {
          button.addEventListener('click', () => {
            const item = this.track.querySelector('.lovelle-categories__item');
            if (!item) return;
            const step = item.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0);
            const rtl = getComputedStyle(this.track).direction === 'rtl';
            this.track.scrollBy({left: Number(button.dataset.direction) * step * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
          }, options);
        });
        this.track.addEventListener('scroll', () => this.updateControls(), { ...options, passive: true });
        this.media.addEventListener('change', () => { this.track.scrollLeft = 0; this.updateControls(); }, options);
        this.observer = new ResizeObserver(() => this.updateControls());
        this.observer.observe(this.track);
        document.addEventListener('shopify:block:select', event => {
          const block = [...this.querySelectorAll('.lovelle-categories__item')].find(item => {
            try { return JSON.parse(item.getAttribute('data-shopify-editor-block') || '{}').id === event.detail.blockId; } catch { return false; }
          });
          if (block && this.isSlider()) block.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
        }, options);
        this.updateControls();
      }
      isSlider() { return (this.media.matches ? this.dataset.mobile : this.dataset.desktop) === 'slider'; }
      updateControls() {
        if (!this.controls) return;
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.controls.hidden = !this.isSlider() || max < 2;
        const position = Math.abs(this.track.scrollLeft);
        this.querySelector('[data-direction="-1"]').disabled = position < 2;
        this.querySelector('[data-direction="1"]').disabled = position >= max - 2;
      }
      disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
    }
    customElements.define('lovelle-category-list', LovelleCategoryList);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lovelle-collection-showcase"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('lovelle-collection-showcase')){
class LovelleCollectionShowcase extends HTMLElement{
connectedCallback(){this.abort?.abort();this.abort=new AbortController();const options={signal:this.abort.signal};this.tabs=[...this.querySelectorAll('[data-tab]')];this.panels=[...this.querySelectorAll('[data-panel]')];this.tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>this.select(i),options);tab.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'&&matchMedia('(min-width:768px)').matches)this.select(i)},options);tab.addEventListener('keydown',e=>{let n;if(e.key==='ArrowRight'||e.key==='ArrowDown')n=(i+1)%this.tabs.length;if(e.key==='ArrowLeft'||e.key==='ArrowUp')n=(i+this.tabs.length-1)%this.tabs.length;if(e.key==='Home')n=0;if(e.key==='End')n=this.tabs.length-1;if(n!==undefined){e.preventDefault();this.select(n);this.tabs[n].focus()}},options)});this.querySelectorAll('[data-thumbnail]').forEach(b=>b.addEventListener('click',()=>{const panel=b.closest('[data-panel]'),hero=panel.querySelector('[data-hero-link]');let img=hero.querySelector('img');if(!img){hero.replaceChildren();img=document.createElement('img');img.width=1000;img.height=1000;hero.append(img)}img.removeAttribute('srcset');img.removeAttribute('sizes');img.src=b.dataset.src;img.alt=b.dataset.title;hero.href=b.dataset.url;hero.setAttribute('aria-label',b.dataset.title);panel.querySelectorAll('[data-thumbnail]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)))},options));document.addEventListener('shopify:block:select',e=>{const i=this.tabs.findIndex(t=>t.dataset.key===e.detail.blockId);if(i>=0)this.select(i)},options)}
select(index){this.tabs.forEach((t,i)=>{t.setAttribute('aria-selected',String(i===index));t.tabIndex=i===index?0:-1;this.panels[i].hidden=i!==index})}
disconnectedCallback(){this.abort?.abort()}
}customElements.define('lovelle-collection-showcase',LovelleCollectionShowcase);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lovelle-footer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lovelle-footer')) {
  customElements.define('lovelle-footer', class extends HTMLElement {
    connectedCallback() {
      this.media = window.matchMedia('(min-width: 750px)');
      this.sync = () => this.querySelectorAll('details').forEach(item => { item.open = this.media.matches; });
      this.guard = event => { if (this.media.matches && event.target.closest('summary')) event.preventDefault(); };
      this.media.addEventListener('change', this.sync);
      this.addEventListener('click', this.guard);
      this.sync();
    }
    disconnectedCallback() {
      this.media.removeEventListener('change', this.sync);
      this.removeEventListener('click', this.guard);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lovelle-instagram"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lovelle-instagram-gallery')) {
    class LovelleInstagramGallery extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('.lovelle-instagram__track');
        this.controls = this.querySelector('.lovelle-instagram__controls');
        this.media = matchMedia('(max-width: 749px)');
        if (!this.track) return;
        this.querySelectorAll('[data-direction]').forEach(button => {
          button.addEventListener('click', () => {
            const item = this.track.querySelector('.lovelle-instagram__item');
            if (!item) return;
            const step = item.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0);
            const rtl = getComputedStyle(this.track).direction === 'rtl';
            this.track.scrollBy({left: Number(button.dataset.direction) * step * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
          }, options);
        });
        this.track.addEventListener('scroll', () => this.updateControls(), { ...options, passive: true });
        this.media.addEventListener('change', () => { this.track.scrollLeft = 0; this.updateControls(); }, options);
        this.observer = new ResizeObserver(() => this.updateControls());
        this.observer.observe(this.track);
        document.addEventListener('shopify:block:select', event => {
          const block = [...this.querySelectorAll('.lovelle-instagram__item')].find(item => {
            try { return JSON.parse(item.getAttribute('data-shopify-editor-block') || '{}').id === event.detail.blockId; } catch { return false; }
          });
          if (block && this.isSlider()) block.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
        }, options);
        this.updateControls();
      }
      isSlider() { return (this.media.matches ? this.dataset.mobile : this.dataset.desktop) === 'slider'; }
      updateControls() {
        if (!this.controls) return;
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.controls.hidden = !this.isSlider() || max < 2;
        const position = Math.abs(this.track.scrollLeft);
        this.querySelector('[data-direction="-1"]').disabled = position < 2;
        this.querySelector('[data-direction="1"]').disabled = position >= max - 2;
      }
      disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
    }
    customElements.define('lovelle-instagram-gallery', LovelleInstagramGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lovelle-memories"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('lovelle-shop-look')){
class LovelleShopLook extends HTMLElement{
connectedCallback(){
 this.abort?.abort();this.abort=new AbortController();const opts={signal:this.abort.signal};this.track=this.querySelector('[data-track]');this.cards=[...this.querySelectorAll('[data-look-card]')];this.dots=[...this.querySelectorAll('[data-hotspot]')];this.index=0;this.paused=false;this.hovered=false;this.focused=false;this.editorSelected=false;this.motion=matchMedia('(prefers-reduced-motion:reduce)');
 if(!this.cards.length)return;
 this.dots.forEach(dot=>{const select=()=>this.select(this.cards.findIndex(c=>c.dataset.key===dot.dataset.key),true);dot.addEventListener('click',select,opts);dot.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'&&matchMedia('(min-width:768px)').matches)select()},opts)});
 const controls=this.querySelector('[data-controls]');controls.hidden=this.cards.length<2;
 this.querySelector('[data-prev]').addEventListener('click',()=>this.select(this.index-1,true),opts);this.querySelector('[data-next]').addEventListener('click',()=>this.select(this.index+1,true),opts);
 const pause=this.querySelector('[data-pause]');if(pause)pause.addEventListener('click',()=>{this.paused=!this.paused;pause.setAttribute('aria-label',this.paused?pause.dataset.playLabel:pause.dataset.pauseLabel);pause.querySelector('span').textContent=this.paused?'▶':'Ⅱ';this.schedule()},opts);
 this.track.addEventListener('scroll',()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>{const width=this.track.clientWidth;if(width)this.activate(Math.max(0,Math.min(this.cards.length-1,Math.round(this.track.scrollLeft/width))),false)})},{...opts,passive:true});
 this.track.addEventListener('keydown',e=>{if(e.target!==this.track)return;if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();this.select(this.index+(e.key==='ArrowRight'?1:-1),true)}},opts);
 this.addEventListener('focusin',()=>{this.focused=true;this.schedule()},opts);this.addEventListener('focusout',()=>queueMicrotask(()=>{if(this.isConnected){this.focused=this.contains(document.activeElement);this.schedule()}}),opts);
 document.addEventListener('visibilitychange',()=>this.schedule(),opts);this.motion.addEventListener('change',()=>this.schedule(),opts);
 document.addEventListener('shopify:block:select',e=>{const index=this.cards.findIndex(c=>c.dataset.key===e.detail.blockId);if(index>=0){this.editorSelected=true;this.select(index,true)}},opts);document.addEventListener('shopify:block:deselect',e=>{if(this.cards.some(c=>c.dataset.key===e.detail.blockId)){this.editorSelected=false;this.schedule()}},opts);
 this.resize=new ResizeObserver(()=>{this.track.scrollLeft=this.index*this.track.clientWidth});this.resize.observe(this.track);
 let saved=[];try{saved=JSON.parse(localStorage.getItem('lovelle-look-favourites')||'[]');if(!Array.isArray(saved))saved=[]}catch{}
 const syncWish=()=>this.querySelectorAll('[data-wish]').forEach(b=>{const on=saved.includes(b.dataset.wish);b.setAttribute('aria-pressed',String(on));b.setAttribute('aria-label',on?b.dataset.saved:b.dataset.save)});
 this.querySelectorAll('[data-wish]').forEach(b=>b.addEventListener('click',()=>{saved=saved.includes(b.dataset.wish)?saved.filter(h=>h!==b.dataset.wish):[...saved,b.dataset.wish];try{localStorage.setItem('lovelle-look-favourites',JSON.stringify(saved))}catch{}syncWish()},opts));syncWish();this.activate(0,false);this.schedule();
}
select(index,manual){if(index<0)index=this.cards.length-1;if(index>=this.cards.length)index=0;this.activate(index,manual);this.track.scrollLeft=index*this.track.clientWidth;this.schedule()}
activate(index,manual){this.index=index;this.cards.forEach((c,i)=>{c.inert=i!==index;c.setAttribute('aria-hidden',String(i!==index))});this.dots.forEach(d=>d.setAttribute('aria-pressed',String(d.dataset.key===this.cards[index].dataset.key)));const counter=this.querySelector('[data-count]');counter.setAttribute('aria-live',manual?'polite':'off');counter.textContent=(index+1)+' / '+this.cards.length}
schedule(){clearTimeout(this.timer);if(!this.isConnected||this.cards.length<2||this.dataset.autoplay!=='true'||this.paused||this.hovered||this.focused||this.editorSelected||this.motion.matches||document.hidden)return;this.timer=setTimeout(()=>this.select(this.index+1,false),Number(this.dataset.delay)||4000)}
disconnectedCallback(){clearTimeout(this.timer);cancelAnimationFrame(this.frame);this.abort?.abort();this.resize?.disconnect()}
}
customElements.define('lovelle-shop-look',LovelleShopLook);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lovelle-product-tabs"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('lovelle-product-tabs')){
  class LovelleProductTabs extends HTMLElement{
    connectedCallback(){
      this.controller?.abort();this.controller=new AbortController();const options={signal:this.controller.signal};
      this.tabs=[...this.querySelectorAll('[data-tab]')];this.panels=[...this.querySelectorAll('[data-panel]')];this.media=matchMedia('(max-width:749px)');
      this.tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>this.activate(i),options);tab.addEventListener('keydown',e=>{let n;if(e.key==='ArrowRight')n=(i+1)%this.tabs.length;if(e.key==='ArrowLeft')n=(i+this.tabs.length-1)%this.tabs.length;if(e.key==='Home')n=0;if(e.key==='End')n=this.tabs.length-1;if(n!==undefined){e.preventDefault();this.activate(n);this.tabs[n].focus()}},options)});
      this.panels.forEach(panel=>{const track=panel.querySelector('.lovelle-product-tabs__products');track.addEventListener('scroll',()=>this.update(),{...options,passive:true});panel.querySelectorAll('[data-slide]').forEach(button=>button.addEventListener('click',()=>{const card=track.querySelector('article');if(!card)return;const gap=parseFloat(getComputedStyle(track).columnGap)||0;const rtl=getComputedStyle(track).direction==='rtl';track.scrollBy({left:Number(button.dataset.slide)*(card.getBoundingClientRect().width+gap)*(rtl?-1:1),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});},options))});
      this.observer=new ResizeObserver(()=>this.update());this.panels.forEach(panel=>this.observer.observe(panel.querySelector('.lovelle-product-tabs__products')));this.media.addEventListener('change',()=>this.update(),options);
      document.addEventListener('shopify:block:select',event=>{const i=this.tabs.findIndex(tab=>{try{return JSON.parse(tab.getAttribute('data-shopify-editor-block')||'{}').id===event.detail.blockId}catch{return false}});if(i>=0)this.activate(i)},options);this.update();
    }
    activate(index){this.tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;this.panels[i].hidden=i!==index});this.update()}
    update(){const slider=(this.media.matches?this.dataset.mobile:this.dataset.desktop)==='slider';this.panels.forEach(panel=>{if(panel.hidden)return;const controls=panel.querySelector('.lovelle-product-tabs__controls');if(!controls)return;const track=panel.querySelector('.lovelle-product-tabs__products');const max=track.scrollWidth-track.clientWidth;controls.hidden=!slider||max<2;const position=Math.abs(track.scrollLeft);controls.querySelector('[data-slide="-1"]').disabled=position<2;controls.querySelector('[data-slide="1"]').disabled=position>=max-2})}
    disconnectedCallback(){this.controller?.abort();this.observer?.disconnect()}
  }
  customElements.define('lovelle-product-tabs',LovelleProductTabs);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lovelle-sale-products"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('lovelle-sale-products')){
  class LovelleSaleProducts extends HTMLElement{
    connectedCallback(){
      this.controller?.abort();this.controller=new AbortController();const options={signal:this.controller.signal};
      this.tabs=[...this.querySelectorAll('[data-tab]')];this.panels=[...this.querySelectorAll('[data-panel]')];this.media=matchMedia('(max-width:749px)');
      this.tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>this.activate(i),options);tab.addEventListener('keydown',e=>{let n;if(e.key==='ArrowRight')n=(i+1)%this.tabs.length;if(e.key==='ArrowLeft')n=(i+this.tabs.length-1)%this.tabs.length;if(e.key==='Home')n=0;if(e.key==='End')n=this.tabs.length-1;if(n!==undefined){e.preventDefault();this.activate(n);this.tabs[n].focus()}},options)});
      this.panels.forEach(panel=>{const track=panel.querySelector('.lovelle-sale-products__products');track.addEventListener('scroll',()=>this.update(),{...options,passive:true});panel.querySelectorAll('[data-slide]').forEach(button=>button.addEventListener('click',()=>{const card=track.querySelector('article');if(!card)return;const gap=parseFloat(getComputedStyle(track).columnGap)||0;const rtl=getComputedStyle(track).direction==='rtl';track.scrollBy({left:Number(button.dataset.slide)*(card.getBoundingClientRect().width+gap)*(rtl?-1:1),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});},options))});
      this.observer=new ResizeObserver(()=>this.update());this.panels.forEach(panel=>this.observer.observe(panel.querySelector('.lovelle-sale-products__products')));this.media.addEventListener('change',()=>this.update(),options);
      document.addEventListener('shopify:block:select',event=>{const i=this.tabs.findIndex(tab=>{try{return JSON.parse(tab.getAttribute('data-shopify-editor-block')||'{}').id===event.detail.blockId}catch{return false}});if(i>=0)this.activate(i)},options);this.update();
    }
    activate(index){this.tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;this.panels[i].hidden=i!==index});this.update()}
    update(){const slider=(this.media.matches?this.dataset.mobile:this.dataset.desktop)==='slider';this.panels.forEach(panel=>{if(panel.hidden)return;const controls=panel.querySelector('.lovelle-sale-products__controls');if(!controls)return;const track=panel.querySelector('.lovelle-sale-products__products');const max=track.scrollWidth-track.clientWidth;controls.hidden=!slider||max<2;const position=Math.abs(track.scrollLeft);controls.querySelector('[data-slide="-1"]').disabled=position<2;controls.querySelector('[data-slide="1"]').disabled=position>=max-2})}
    disconnectedCallback(){this.controller?.abort();this.observer?.disconnect()}
  }
  customElements.define('lovelle-sale-products',LovelleSaleProducts);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
